import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useUID } from 'dibs-uid';
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import HpLazyImageWrapper from '../HpLazyImageWrapper/HpLazyImageWrapper';
import ResponsiveImage from '../ResponsiveImage';

import styles from './HpRespPromoModulePromoItemOld.scss';

function HpRespPromoModulePromoItemOld({
    promotion,
    className,
    onClick,
    isFullBleedImage,
    useLazyLoadImages,
}) {
    const {
        mobileImageUrl,
        imageUrl,
        linkData,
        imageHeight,
        imageWidth,
        mobileImageHeight,
        mobileImageWidth,
    } = promotion;

    const uid = useUID() || undefined;
    const promoItemId = `promomodulepromo-${uid}`;
    const itemClassNames = classnames(styles.item, className);

    const shownImageUrl = imageUrl || mobileImageUrl;

    return (
        <div className={itemClassNames}>
            {promotion.imageCopy && (
                <span id={promoItemId} className={styles.imageCopy}>
                    {promotion.imageCopy}
                </span>
            )}
            <SeoLink
                linkData={linkData}
                className={styles.link}
                onClick={onClick}
                ariaLabel={promotion.cta}
                ariaDescribedBy={promotion.imageCopy ? promoItemId : undefined}
            >
                <HpLazyImageWrapper
                    useLazyLoad={useLazyLoadImages}
                    imageHeight={mobileImageHeight || imageHeight}
                    imageWidth={mobileImageWidth || imageWidth}
                >
                    <ResponsiveImage
                        ariaHidden
                        className={classnames(styles.image, {
                            [styles.isFullBleed]: isFullBleedImage,
                        })}
                        src={shownImageUrl}
                        srcSetWidths={[400, 640, 960, 1280, 1440]}
                    />
                </HpLazyImageWrapper>
            </SeoLink>
        </div>
    );
}

HpRespPromoModulePromoItemOld.propTypes = {
    promotion: PropTypes.shape({
        imageUrl: PropTypes.string,
        mobileImageUrl: PropTypes.string,
        imageHeight: PropTypes.string,
        imageWidth: PropTypes.string,
        mobileImageHeight: PropTypes.string,
        mobileImageWidth: PropTypes.string,
        alignment: PropTypes.string,
        cta: PropTypes.string,
        imageCopy: PropTypes.string,
        linkData: PropTypes.object.isRequired,
    }).isRequired,
    className: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    isFullBleedImage: PropTypes.bool,
    useLazyLoadImages: PropTypes.bool,
};

HpRespPromoModulePromoItemOld.defaultProps = {
    onClick: () => {},
};

export { HpRespPromoModulePromoItemOld };
